/* Newsletter-Popup — Auslöser, Ruhezeiten, Anmeldung.
 *
 * Die Steuerung ist von Omnisend übernommen, weil sie sich dort bewährt hat:
 * 25 % Scrolltiefe oder Verlassen der Seite, danach zwei Stunden Ruhe.
 *
 * Sechs Fälle, in denen es NICHT erscheint:
 *   1. Er ist eingeloggt und hat den Newsletter schon — das entscheidet Liquid,
 *      dann wird das Fenster gar nicht erst ausgeliefert.
 *   2. Der Merkzettel-Cookie `gd_nl` liegt vor. Den setzt die
 *      Bestätigungsseite auf `.getdigital.de`; er greift also auch ohne Login
 *      und über Unterdomains hinweg. Beim Abmelden wird er wieder gelöscht.
 *   3. Der Besucher hat es kürzlich weggeklickt (Ruhezeit läuft noch).
 *   4. Er hat sich hierüber schon angemeldet.
 *   5. Die Adresse enthält einen ausgeschlossenen Pfad (Konto, Abo-Verwaltung).
 *   6. Er kommt gerade aus einer unserer Newsletter-Mails.
 *
 * Der letzte Fall ist der am leichtesten zu übersehende:
 * Wer eben auf einen Link im Newsletter geklickt hat, hat den Newsletter
 * offensichtlich schon. Ihm ein Anmeldefenster vorzusetzen, wirkt schlicht
 * unaufmerksam. Erkannt wird es an utm_source, das unsere Mail-Links tragen;
 * die Entscheidung gilt für die ganze Sitzung, nicht nur für die erste Seite.
 *
 * Eine Lücke bleibt: Wer sich vor Einführung des Merkzettels angemeldet hat,
 * nicht eingeloggt ist und gerade nicht aus einer Mail kommt, sieht das Fenster
 * einmal. Danach greift die Ruhezeit. Das ist der Preis dafür, keine
 * Besucherprofile zu führen.
 *
 * IM THEME-EDITOR öffnet das Fenster nur, solange die Section in der
 * Seitenleiste angewählt ist — sonst überlagert es dort jede Seite und stört
 * beim Bearbeiten des restlichen Themes.
 *
 * ZUM TESTEN: ?nl=1 an die Adresse hängen. Dann werden die Regeln 2 bis 6
 * übergangen und das Fenster öffnet sofort, ohne auf Scrolltiefe oder
 * Exit-Intent zu warten. Der Testlauf hinterlässt bewusst keine Spur — weder
 * Ruhezeit noch Anmelde-Merker —, sonst wäre nach dem ersten Versuch für zwei
 * Stunden Schluss.
 *
 * Regel 1 lässt sich damit NICHT übergehen: Ob ein eingeloggter Abonnent das
 * Fenster überhaupt bekommt, entscheidet Liquid auf dem Server, und Liquid
 * sieht die Query-Parameter nicht. Wer eingeloggt und angemeldet ist, findet
 * `[data-nlp]` gar nicht erst im DOM — dann hilft nur Ausloggen oder ein
 * Inkognito-Fenster.
 */
(function () {
  'use strict';

  const root = document.querySelector('[data-nlp]');
  if (!root) return;

  /* Im Theme-Editor erscheint das Fenster nie von selbst — dort überlagert es
     sonst auf jeder Seite die Arbeit. Es öffnet nur, solange die Section in
     der Seitenleiste angewählt ist. Der Editor rendert die Section bei jeder
     Einstellungsänderung neu und führt dieses Skript dann erneut aus; die
     Listener liegen deshalb einmalig auf document und suchen sich das Fenster
     im Moment des Ereignisses, statt sich das alte Element zu merken. */
  if (window.Shopify && window.Shopify.designMode) {
    if (!window.gdNlpEditorBereit) {
      window.gdNlpEditorBereit = true;
      const fenster = (e) => e.target.querySelector('[data-nlp]');
      document.addEventListener('shopify:section:select', (e) => {
        const el = fenster(e);
        if (el) el.hidden = false;
      });
      document.addEventListener('shopify:section:deselect', (e) => {
        const el = fenster(e);
        if (el) el.hidden = true;
      });
      // Auch der X-Knopf schliesst hier — aber ohne Ruhezeit zu setzen.
      document.addEventListener('click', (e) => {
        if (e.target.closest('[data-nlp-close]')) {
          const el = e.target.closest('[data-nlp]');
          if (el) el.hidden = true;
        }
      });
    }
    return;
  }

  const SPEICHER_RUHE = 'nlp:ruheBis';
  const SPEICHER_ANGEMELDET = 'nlp:angemeldet';
  const SITZUNG_AUS_MAIL = 'nlp:ausMail';
  /* Merkzettel, den die Bestätigungsseite auf .getdigital.de setzt. Er sagt
     nur "ist Abonnent, nicht mehr fragen" und wird beim Abmelden gelöscht. */
  const COOKIE_ABONNENT = 'gd_nl';
  /** utm_source, das unsere eigenen Mail-Links setzen (siehe tracking.server.ts). */
  const EIGENE_MAIL_QUELLE = 'nerd-mailer';

  const strings = JSON.parse(entschluesseln(root.dataset.strings || '{}'));
  const scrollProzent = parseInt(root.dataset.scrollPercent || '25', 10);
  const exitIntent = root.dataset.exitIntent === 'true';
  const ruheStunden = parseFloat(root.dataset.quietHours || '2');
  const ausgeschlossen = (entschluesseln(root.dataset.excludedPaths || ''))
    .split('\n').map((z) => z.trim()).filter(Boolean);

  const form = root.querySelector('[data-nlp-form]');
  const input = form?.querySelector('input[name="email"]');
  const dialog = root.querySelector('.nlp-dialog');
  const fehlerEl = form?.querySelector('[data-nlp-error]');
  let offen = false;
  let vorherFokussiert = null;

  /** ?nl=1 — Testmodus, siehe Kopf der Datei. */
  const erzwungen = (() => {
    try {
      return new URLSearchParams(window.location.search).get('nl') === '1';
    } catch {
      return false;
    }
  })();

  merkeMailHerkunft();
  if (erzwungen) {
    öffnen();
  } else if (darfErscheinen()) {
    auslöserScharfMachen();
  }

  // ───────────────────────────────────────────────────────────────────────
  function merkeMailHerkunft() {
    try {
      const p = new URLSearchParams(window.location.search);
      if (p.get('utm_source') === EIGENE_MAIL_QUELLE) {
        sessionStorage.setItem(SITZUNG_AUS_MAIL, '1');
      }
    } catch { /* Speicher gesperrt — dann greift die Regel eben nicht */ }
  }

  function darfErscheinen() {
    const pfad = window.location.pathname + window.location.search;
    if (ausgeschlossen.some((teil) => pfad.indexOf(teil) !== -1)) return false;

    // Der Merkzettel der Bestätigungsseite gilt geräteweit, auch ohne Login.
    if (hatCookie(COOKIE_ABONNENT)) return false;

    try {
      if (sessionStorage.getItem(SITZUNG_AUS_MAIL)) return false;
      if (localStorage.getItem(SPEICHER_ANGEMELDET)) return false;
      const bis = parseInt(localStorage.getItem(SPEICHER_RUHE) || '0', 10);
      if (bis && Date.now() < bis) return false;
    } catch { /* Ohne Speicher zeigen wir es — lieber einmal zu viel */ }

    return true;
  }

  function auslöserScharfMachen() {
    let ausgelöst = false;
    const einmal = () => {
      if (ausgelöst) return;
      ausgelöst = true;
      window.removeEventListener('scroll', beiScroll);
      document.removeEventListener('mouseout', beiVerlassen);
      öffnen();
    };

    const beiScroll = () => {
      const höhe = document.documentElement.scrollHeight - window.innerHeight;
      if (höhe <= 0) return;
      const anteil = (window.scrollY / höhe) * 100;
      if (anteil >= scrollProzent) einmal();
    };

    // Exit-Intent: Der Zeiger verlässt das Fenster nach oben, also Richtung
    // Adresszeile oder Tabs. Auf Geräten ohne Zeiger gibt es das nicht — dort
    // bleibt die Scrolltiefe der einzige Auslöser.
    const beiVerlassen = (e) => {
      if (e.clientY <= 0 && !e.relatedTarget) einmal();
    };

    if (scrollProzent <= 0) {
      einmal();
      return;
    }
    window.addEventListener('scroll', beiScroll, { passive: true });
    if (exitIntent) document.addEventListener('mouseout', beiVerlassen);
  }

  function öffnen() {
    vorherFokussiert = document.activeElement;
    root.hidden = false;
    offen = true;
    document.body.style.overflow = 'hidden';
    // Auf Touch-Geräten nicht ins Eingabefeld: Das klappt sofort die Tastatur
    // auf, und die Seite springt hin und her, bevor jemand überhaupt gelesen
    // hat, worum es geht. Dort bekommt der Dialog selbst den Fokus — der
    // Screenreader landet trotzdem im Fenster, getippt wird erst nach Antippen.
    if (window.matchMedia('(pointer: coarse)').matches) {
      dialog?.focus({ preventScroll: true });
    } else {
      input?.focus();
    }
    document.addEventListener('keydown', beiTaste);
    root.querySelectorAll('[data-nlp-close]').forEach((el) =>
      el.addEventListener('click', schliessen),
    );
  }

  function schliessen() {
    if (!offen) return;
    offen = false;
    root.hidden = true;
    document.body.style.overflow = '';
    document.removeEventListener('keydown', beiTaste);
    // Im Testmodus keine Ruhezeit setzen, sonst blockiert der erste Versuch
    // die nächsten zwei Stunden.
    if (!erzwungen) {
      try {
        localStorage.setItem(SPEICHER_RUHE, String(Date.now() + ruheStunden * 3600_000));
      } catch { /* egal */ }
    }
    vorherFokussiert?.focus?.();
  }

  function beiTaste(e) {
    if (e.key === 'Escape') schliessen();
  }

  form?.addEventListener('submit', (e) => {
    e.preventDefault();
    absenden();
  });

  async function absenden() {
    setFehler('');
    const email = (input?.value || '').trim();
    // Grobe Vorprüfung, damit ein Tippfehler nicht erst eine Anfrage kostet.
    // Verbindlich prüft der Server.
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setFehler(strings.err_email || 'Bitte gib eine gültige E-Mail-Adresse ein.');
      input?.focus();
      return;
    }

    const knopf = form.querySelector('button[type="submit"]');
    if (knopf) knopf.disabled = true;
    try {
      const res = await fetch('/apps/newsletter/api/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          email: email,
          // Erster Besuch dieses Browsers, siehe erstkontakt.js
          erstkontakt: window.gdErstkontakt ? window.gdErstkontakt() : null,
          source: 'popup',
          // Sprache der Seite: bestimmt Sprache von Bestätigungsmail und -seite.
          // Der App Proxy schickt kein locale mit, siehe proxy.newsletter.api.subscribe.tsx.
          sprache: root.dataset.sprache || '',
          // Nachweis, dass hier ein Mensch sitzt. Siehe turnstile-gate.js.
          turnstileToken: await (window.gdTurnstile?.holeToken?.() ?? Promise.resolve(null)),
        }),
      });
      const data = await res.json().catch(() => null);

      if (res.ok && data && data.ok) {
        // Auch dieser Merker bleibt im Testmodus aus — der zweite Testlauf
        // soll nicht daran scheitern, dass der erste geklappt hat.
        if (!erzwungen) {
          try { localStorage.setItem(SPEICHER_ANGEMELDET, '1'); } catch { /* egal */ }
        }
        zeigeZustand('SUCCESS');
        return;
      }
      if (data && data.error === 'invalid_email') {
        setFehler(strings.err_email || 'Bitte gib eine gültige E-Mail-Adresse ein.');
        return;
      }
      setFehler(strings.err_allgemein || 'Das hat gerade nicht geklappt.');
    } catch (err) {
      console.error('[newsletter-popup] Anmeldung fehlgeschlagen', err);
      setFehler(strings.err_allgemein || 'Das hat gerade nicht geklappt.');
    } finally {
      if (knopf) knopf.disabled = false;
    }
  }

  function zeigeZustand(name) {
    root.querySelectorAll('[data-nlp-state]').forEach((el) => {
      el.hidden = el.dataset.nlpState !== name;
    });
  }

  function setFehler(text) {
    if (fehlerEl) fehlerEl.textContent = text;
  }

  function hatCookie(name) {
    return document.cookie
      .split(';')
      .some((c) => c.trim().indexOf(name + '=') === 0);
  }

  /* Die Werte kommen über data-Attribute aus Liquid und sind dort escaped. */
  function entschluesseln(str) {
    const el = document.createElement('textarea');
    el.innerHTML = str;
    return el.value;
  }
})();
